import '../css/ConfirmDialog.css';
import { Button } from './atoms';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Icon from '@mui/material/Icon';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import * as React from 'react';

interface Props {
  title?: string;
  titleIcon?: boolean;
  text?: string | React.ReactElement;
  open: boolean;
  buttonText: string;
  confirmDisabled?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  onCancel?: () => void;
  onSend: () => void;
  children?: React.ReactNode;
  dataQa?: string;
  cancelText?: string;
}

const ModalBasicExample = (props: Props) => (
  <Dialog
    open={props.open}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth={props.maxWidth || 'xs'}
  >
    <div data-testid={props.dataQa}>
      {props.titleIcon ? (
        <div className="confirm-dialog-title-container">
          <Icon className="confirm-dialog-title-icon">
            <CheckCircleIcon />
          </Icon>
          <h2
            className="confirm-dialog-title"
            data-testid={props.dataQa + '-title'}
          >
            {props.title}
          </h2>
        </div>
      ) : (
        <DialogTitle
          id="alert-dialog-title"
          data-testid={props.dataQa + '-title'}
        >
          {props.title}
        </DialogTitle>
      )}

      <DialogContent>
        {props.text && (
          <DialogContentText
            id="alert-dialog-description"
            data-testid={props.dataQa + '-content'}
          >
            {props.text}
          </DialogContentText>
        )}
        {props.children}
      </DialogContent>
      <DialogActions style={{ justifyContent: 'flex-end' }}>
        {props.onCancel && (
          <Button variant="secondary" size="medium" onClick={props.onCancel}>
            Cancel
          </Button>
        )}
        <Button
          variant="primary"
          size="medium"
          data-testid={`${props.buttonText
            .toLowerCase()
            .replace(/ /g, '-')}-button`}
          onClick={props.onSend}
        >
          {props.buttonText}
        </Button>
      </DialogActions>
    </div>
  </Dialog>
);

export default ModalBasicExample;
